import React, { useEffect, useState } from "react";
import DataTable from "../common/DataTable";
import { api_paths } from "../../config/api.paths";
import API from "../../config/axios";
import { useDispatch } from "react-redux";
import { SET_LOADING } from "../../redux/user";
import { formatToUSDate } from "../../utils/dateFormat";
// import { PiArrowCircleDownThin } from "react-icons/pi";
// import { MdOutlineRemoveRedEye } from "react-icons/md";
import viewicon from "../../assets/images/icons/view.svg";
import downloadicon from "../../assets/images/icons/download.svg";
import { toastErrorMessage } from "../../utils/utils";
import PassDetailsModal from "./PassDetailsModal";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

const PurchasedTickets = ({
  eventId,
  refreshKey,
  tickets: propTickets,
  event,
}) => {
  const [tickets, setTickets] = useState(propTickets || []);
  const [showPassModal, setShowPassModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const dispatch = useDispatch();

  const fetchPurchasedTickets = async () => {
    try {
      dispatch(SET_LOADING(true));

      const res = await API.get(
        `${api_paths.member.EVENTS.PURCHASED_TICKETS}/${eventId}`,
        {
          params: {
            page: 1,
            limit: 100,
          },
        }
      );
      if (res.data?.payload?.result?.data) {
        setTickets(res.data.payload.result.data);
      }
    } catch (error) {
      console.error("Error fetching purchased tickets:", error);
      toastErrorMessage("Failed to fetch purchased tickets");
    } finally {
      dispatch(SET_LOADING(false));
    }
  };

  useEffect(() => {
    if (Array.isArray(propTickets)) {
      setTickets(propTickets);
      return;
    }
    if (eventId) fetchPurchasedTickets();
    // eslint-disable-next-line
  }, [eventId, refreshKey, propTickets]);

  const handleViewPass = (ticket) => {
    setSelectedTicket(ticket);
    setShowPassModal(true);
  };

  const handleDownloadPDF = async (pdf_path) => {
    if (!pdf_path) {
      toastErrorMessage("Ticket PDF is not available");
      return;
    }
    const fileURL = `${IMAGE_BASEURL}${pdf_path}`;
    try {
      const response = await fetch(fileURL);
      if (!response.ok) {
        toastErrorMessage("Ticket PDF is not available");
        return;
      }
      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      const filename = pdf_path.split("/").pop() || "ticket.pdf";
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("PDF download error:", error);
      toastErrorMessage("Ticket PDF is not available");
    }
  };

  const formatGender = (gender) => {
    if (!gender) return "-";
    return gender.charAt(0).toUpperCase() + gender.slice(1);
  };

  const ticketColumns = [
    { key: "name", label: "Name" },
    {
      key: "createdAt",
      label: "Purchase Date",
      render: (val) => formatToUSDate(val?.split("T")[0]),
    },
    { key: "relationship", label: "Relationship" },
    {
      key: "gender",
      label: "Gender",
      render: (val) => formatGender(val),
    },
    {
      key: "actions",
      label: "Actions",
      render: (_, row) => (
        // <div className="d-flex align-items-center gap-2">
        //   {row.qr_code_path && (
        //     <MdOutlineRemoveRedEye
        //       size={22}
        //       className="cursor-pointer text-main"
        //       title="View Ticket"
        //       onClick={() => handleViewPass(row)}
        //     />
        //   )}
        //   {row.pdf_path && (
        //     <PiArrowCircleDownThin
        //       size={22}
        //       className="cursor-pointer text-main"
        //       title="Download Ticket PDF"
        //       onClick={() => handleDownloadPDF(row.pdf_path)}
        //     />
        //   )}
        // </div>
        <div className="d-flex align-items-center gap-2">
          {row.qr_code_path && (
            <img
              src={viewicon} // change to your image path
              alt="View Ticket"
              title="View Ticket"
              className="cursor-pointer purchase-icon"
              onClick={() => handleViewPass(row)}
            />
          )}

          {row.pdf_path && (
            <img
              src={downloadicon} // change to your image path
              alt="Download Ticket PDF"
              title="Download Ticket PDF"
              className="cursor-pointer purchase-icon"
              onClick={() => handleDownloadPDF(row.pdf_path)}
            />
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="purchased-tickets-container">
        <h4 className="mb-4 fw-semibold">Purchased Tickets</h4>
        <DataTable
          columns={ticketColumns}
          data={tickets}
          emptyMessage={"No purchased tickets found."}
        />
      </div>

      <PassDetailsModal
        show={showPassModal}
        onHide={() => setShowPassModal(false)}
        ticket={selectedTicket}
        event={event}
        onDownload={handleDownloadPDF}
      />
    </>
  );
};

export default PurchasedTickets;
